import Auth from 'modules/Auth';
import { PermissionsEnum } from 'consts/permissions';
import { DealStatus, DealType, DealTypeLabel } from 'components/common/types/Deal.types';
import { PublisherType } from 'components/common/types/Publisher.types';
import { dealTypesList, DealTypesList } from 'consts/dealTypesList';

const getAllOptions = (selectedType?: DealType): DealTypesList => {
  const dealTypes: DealTypesList = [];

  if (selectedType === DealType.GUARANTEED || Auth.hasPermission(PermissionsEnum.DEAL_TYPE_PRICEIMPRESSION_VIEW)) {
    dealTypes.push({
      code: DealType.GUARANTEED,
      name: DealTypeLabel.GUARANTEED,
    });
  }

  if (
    selectedType === DealType.NON_GUARANTEED_FLOOR_PRICE ||
    Auth.hasPermission(PermissionsEnum.DEAL_TYPE_NON_GUARANTEED_VIEW)
  ) {
    dealTypes.push({
      code: DealType.NON_GUARANTEED_FLOOR_PRICE,
      name: DealTypeLabel.NON_GUARANTEED_FLOOR_PRICE,
    });
  }

  if (
    selectedType === DealType.NON_GUARANTEED_FIXED_PRICE ||
    Auth.hasPermission(PermissionsEnum.DEAL_TYPE_PRICE_VIEW)
  ) {
    dealTypes.push({
      code: DealType.NON_GUARANTEED_FIXED_PRICE,
      name: DealTypeLabel.NON_GUARANTEED_FIXED_PRICE,
    });
  }

  return dealTypes;
};

const getDealTypes = ({
  dealType,
  isNewDeal,
  publisherType,
  dealStatus,
}: {
  dealType?: DealType;
  isNewDeal?: boolean;
  publisherType?: PublisherType;
  dealStatus?: DealStatus;
}): DealTypesList => {
  const isAllOptionsAvailable = isNewDeal;
  const isDraft = dealStatus === DealStatus.DRAFT;
  const isDealGuaranteed = !isNewDeal && dealType === DealType.GUARANTEED;
  const allOptions = getAllOptions(dealType);

  let dealTypes: DealTypesList = [];

  if (publisherType === PublisherType.RESELLER) {
    dealTypes = allOptions.filter(
      (type) => type.code === DealType.NON_GUARANTEED_FLOOR_PRICE || type.code === DealType.NON_GUARANTEED_FIXED_PRICE,
    );
  } else if (isDraft) {
    dealTypes = allOptions.filter((type) => type.code !== DealType.GUARANTEED);
  } else if (isAllOptionsAvailable) {
    dealTypes = allOptions;
  } else if (isDealGuaranteed) {
    dealTypes = allOptions.filter((type) => type.code === DealType.GUARANTEED);
  } else {
    dealTypes = allOptions.filter((type) => type.code !== DealType.GUARANTEED);
  }

  // when user has no access to any deal type, non-guaranteed should be allowed by default
  if (isNewDeal && dealTypes.length === 0) {
    dealTypes.push({
      code: DealType.NON_GUARANTEED_FLOOR_PRICE,
      name: DealTypeLabel.NON_GUARANTEED_FLOOR_PRICE,
    });
  }

  return dealTypesList.filter(({ code }) => dealTypes.some(({ code: typeCode }) => typeCode === code));
};

export default getDealTypes;
